export default __webpack_public_path__ + "static/media/game-welcome-level3.590098b2.png";